import { Navigate } from 'react-router-dom';
import preloadChunks from '@/routes/preloadChunks.util';

const accountRoutes = [
  {
    path: 'account',
    children: [
      { index: true, element: <Navigate to="profile" replace /> },
      {
        path: 'profile',
        lazy: async () => ({
          Component: (await preloadChunks['profile.main']()).default,
        }),
      },
      {
        path: 'profile/verify-phone',
        lazy: async () => ({
          Component: (await preloadChunks['profile.phoneVerification']())
            .default,
        }),
      },
      {
        path: 'members',
        lazy: async () => ({
          Component: (await preloadChunks['account.members']()).default,
        }),
      },
      {
        path: 'subscription',
        children: [
          {
            index: true,
            lazy: async () => ({
              Component: (await preloadChunks['account.subscription']())
                .default,
            }),
          },
          {
            path: 'checkout',
            lazy: async () => ({
              Component: (await preloadChunks['subscription.checkout']())
                .default,
            }),
          },
        ],
      },
      {
        path: 'invoicing',
        lazy: async () => ({
          Component: (await preloadChunks['account.invoicing']()).default,
        }),
      },
    ],
  },
  {
    path: 'subscriptionMissing',
    element: <Navigate to="/account/subscription" replace />,
  },
];

export default accountRoutes;
